namespace $.$$ {

	$mol_style_define( $shm_hitalama_opencode_map_chat, {

		flex: {
			grow: 0,
			shrink: 0,
		},

		minWidth: '24rem',

		No_map: {
			color: $mol_theme.shade,
			padding: {
				left: $mol_gap.block,
				right: $mol_gap.block,
				top: $mol_gap.block,
				bottom: $mol_gap.block,
			},
		},

	} )

}
